import { styled } from '@mui/material';

import { TPersonaDto } from '@app-velocity/av-api-v2';

import { Typography } from '@app-velocity/ui';

import { describePersonaConfig } from '../../../../../../utils/describePersonaConfig';

const StyledConfig = styled(Typography)({
  color: 'var(--text-text-secondary-color)',
  fontSize: 12,
});

export type PersonaConfigDescriptionProps = {
  persona: TPersonaDto;
};

export const PersonaConfigDescription = ({
  persona,
}: PersonaConfigDescriptionProps) => {
  return (
    <StyledConfig variant="body2">
      {describePersonaConfig(persona)}
    </StyledConfig>
  );
};
